import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import { CreateResourceHandlerToJSON, FindResourceHandlerPayloadToJSON, ResourceHandlerFromJSON } from '../models/index';

/**
 * ResourceHandlerApi - interface
 * 
 * @export
 * @interface ResourceHandlerApiInterface
 */

/**
 * 
 */
export var ResourceHandlerApi = /*#__PURE__*/function (_runtime$BaseAPI) {
  function ResourceHandlerApi() {
    _classCallCheck(this, ResourceHandlerApi);
    return _callSuper(this, ResourceHandlerApi, arguments);
  }
  _inherits(ResourceHandlerApi, _runtime$BaseAPI);
  return _createClass(ResourceHandlerApi, [{
    key: "createResourceHandlerRaw",
    value: (
    /**
     * Create a resource handler.
     * Create a resource handler.
     */
    function () {
      var _createResourceHandlerRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              queryParameters = {};
              headerParameters = {};
              headerParameters['Content-Type'] = 'application/json';
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 8;
                break;
              }
              _context.next = 7;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 7:
              headerParameters["Authorization"] = _context.sent;
            case 8:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 12;
                break;
              }
              _context.next = 11;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 11:
              headerParameters["Authorization"] = _context.sent;
            case 12:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 16;
                break;
              }
              _context.next = 15;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 15:
              headerParameters["Authorization"] = _context.sent;
            case 16:
              _context.next = 18;
              return this.request({
                path: "/resourcehandlers",
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateResourceHandlerToJSON(requestParameters['createResourceHandler'])
              }, initOverrides);
            case 18:
              response = _context.sent;
              return _context.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                return ResourceHandlerFromJSON(jsonValue);
              }));
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createResourceHandlerRaw(_x, _x2) {
        return _createResourceHandlerRaw.apply(this, arguments);
      }
      return createResourceHandlerRaw;
    }()
    /**
     * Create a resource handler.
     * Create a resource handler.
     */
    )
  }, {
    key: "createResourceHandler",
    value: (function () {
      var _createResourceHandler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var requestParameters,
          initOverrides,
          response,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              requestParameters = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              initOverrides = _args2.length > 1 ? _args2[1] : undefined;
              _context2.next = 4;
              return this.createResourceHandlerRaw(requestParameters, initOverrides);
            case 4:
              response = _context2.sent;
              _context2.next = 7;
              return response.value();
            case 7:
              return _context2.abrupt("return", _context2.sent);
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function createResourceHandler() {
        return _createResourceHandler.apply(this, arguments);
      }
      return createResourceHandler;
    }()
    /**
     * Delete a registered resource handler.
     * Delete a registered resource handler.
     */
    )
  }, {
    key: "deleteResourceHandlerRaw",
    value: (function () {
      var _deleteResourceHandlerRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(requestParameters['encodedResourceHandlerRID'] == null)) {
                _context3.next = 2;
                break;
              }
              throw new runtime.RequiredError('encodedResourceHandlerRID', 'Required parameter "encodedResourceHandlerRID" was null or undefined when calling deleteResourceHandler().');
            case 2:
              queryParameters = {};
              headerParameters = {};
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 9;
                break;
              }
              _context3.next = 8;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 8:
              headerParameters["Authorization"] = _context3.sent;
            case 9:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 13;
                break;
              }
              _context3.next = 12;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 12:
              headerParameters["Authorization"] = _context3.sent;
            case 13:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 17;
                break;
              }
              _context3.next = 16;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 16:
              headerParameters["Authorization"] = _context3.sent;
            case 17:
              _context3.next = 19;
              return this.request({
                path: "/resourcehandlers/{encodedResourceHandlerRID}".replace("{".concat("encodedResourceHandlerRID", "}"), encodeURIComponent(String(requestParameters['encodedResourceHandlerRID']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters
              }, initOverrides);
            case 19:
              response = _context3.sent;
              return _context3.abrupt("return", new runtime.VoidApiResponse(response));
            case 21:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function deleteResourceHandlerRaw(_x3, _x4) {
        return _deleteResourceHandlerRaw.apply(this, arguments);
      }
      return deleteResourceHandlerRaw;
    }()
    /**
     * Delete a registered resource handler.
     * Delete a registered resource handler.
     */
    )
  }, {
    key: "deleteResourceHandler",
    value: (function () {
      var _deleteResourceHandler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(requestParameters, initOverrides) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.deleteResourceHandlerRaw(requestParameters, initOverrides);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function deleteResourceHandler(_x5, _x6) {
        return _deleteResourceHandler.apply(this, arguments);
      }
      return deleteResourceHandler;
    }()
    /**
     * Find the registered resource handler.
     * Find the registered resource handler.
     */
    )
  }, {
    key: "findResourceHandlerRaw",
    value: (function () {
      var _findResourceHandlerRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              queryParameters = {};
              headerParameters = {};
              headerParameters['Content-Type'] = 'application/json';
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 8;
                break;
              }
              _context5.next = 7;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 7:
              headerParameters["Authorization"] = _context5.sent;
            case 8:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 12;
                break;
              }
              _context5.next = 11;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 11:
              headerParameters["Authorization"] = _context5.sent;
            case 12:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 16;
                break;
              }
              _context5.next = 15;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 15:
              headerParameters["Authorization"] = _context5.sent;
            case 16:
              _context5.next = 18;
              return this.request({
                path: "/resourcehandlers/find",
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FindResourceHandlerPayloadToJSON(requestParameters['findResourceHandlerPayload'])
              }, initOverrides);
            case 18:
              response = _context5.sent;
              return _context5.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                return ResourceHandlerFromJSON(jsonValue);
              }));
            case 20:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function findResourceHandlerRaw(_x7, _x8) {
        return _findResourceHandlerRaw.apply(this, arguments);
      }
      return findResourceHandlerRaw;
    }()
    /**
     * Find the registered resource handler.
     * Find the registered resource handler.
     */
    )
  }, {
    key: "findResourceHandler",
    value: (function () {
      var _findResourceHandler = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var requestParameters,
          initOverrides,
          response,
          _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              requestParameters = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
              initOverrides = _args6.length > 1 ? _args6[1] : undefined;
              _context6.next = 4;
              return this.findResourceHandlerRaw(requestParameters, initOverrides);
            case 4:
              response = _context6.sent;
              _context6.next = 7;
              return response.value();
            case 7:
              return _context6.abrupt("return", _context6.sent);
            case 8:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function findResourceHandler() {
        return _findResourceHandler.apply(this, arguments);
      }
      return findResourceHandler;
    }())
  }]);
}(runtime.BaseAPI);